import { FC } from "react";
import { IClassname } from "@/lib/types/classname";

export const FilterMall: FC<IClassname> = ({ className }) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 9.46379C11.2176 9.30379 11.8352 8.78702 12.328 8.37104C12.6248 8.11623 12.8366 7.77671 12.9348 7.39805C13.0331 7.0194 13.0131 6.61976 12.8776 6.25278C12.7421 5.88581 12.4975 5.56909 12.1768 5.34514C11.856 5.1212 11.4744 5.00076 11.0832 5H11C9.896 5 9 5.89596 9 6.9999V7.39989M11 9.46379C8.8912 11.0013 6.3968 11.9309 3.704 12.5116L3 12.6636V15.3995L3.2864 15.5147C8.23811 17.4951 13.7619 17.4951 18.7136 15.5147L19 15.3995V12.6636L18.296 12.5116C15.6032 11.9309 13.1088 11.0013 11 9.46379Z"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  );
};
